export const initialState = {
    is_loading: true,
    total_pages: 0,
    current_page: 1,
    logs_list: [],
    search_text: ""
}